import * as React from "react";

import { useState, useEffect } from 'react';

import Snackbar from "@mui/material/Snackbar";
import { Storefront } from "../models/StorefrontResponse";
import { Button, Container, FormControl, Grid, IconButton, LinearProgress, Paper, Stack, TextField, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { User } from "../models/UsersResponse";
import { useFileUpload } from "../hooks/useFileUpload";


// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const window: any; // Needed for Hubspot

interface Props {
    storefront: Storefront
    customer: User | undefined
}

const LeadEnhancement = (props: Props) => {
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [snackbarMsg, setSnackbarMsg] = useState("")
    const [uploadFormData, setUploadFormData] = useState<FormData>(new FormData())
    const [startUpload, setStartUpload] = useState(false)

    const {uploadProgress, uploadError} = useFileUpload(uploadFormData, startUpload, props.customer?.id || "")

    useEffect(() => {
        // Log Pageview with Hubspot
        const _hsq = window._hsq = window._hsq || [];
        _hsq.push(['setPath', '/lead-enhancement']);
        _hsq.push(['trackPageView']);

    }, []);

    useEffect(() => {
        if (uploadError) {
            setSnackbarMsg(uploadError)
            setOpenSnackbar(true)
        }
    }, [uploadError])

    const uploadButtonClicked = () => {
        setStartUpload(true)
    }

    const uploadFilenameChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (files) {
            const file = files[0];
            const formData = new FormData();
            formData.append('file', file);
            setUploadFormData(formData);
        }
    }

    const handleSnackbarClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnackbar(false);
    };

    const snackbarAction = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleSnackbarClose}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );


    return (
        <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
                        <Stack direction="column" justifyContent="space-between" alignItems="flex-start" spacing={2}>
                            <Typography variant="h6" sx={{ color: props.storefront.activeColors.mainPage.pageText }}>Lead Enhancement</Typography>
                            <Typography variant="body1" sx={{ color: props.storefront.activeColors.mainPage.pageText }}>Have existing data you'd like to add Phones, Emails, Addresses or other data to? If so, we can enhance your data for as little as 10 cents/item. Upload your file below to get started!</Typography>
                        </Stack>
                        <Grid item xs={12}>
                            <Paper sx={{ paddingTop: 2, display: "flex", flexDirection: "column" }}>
                                <Grid
                                    sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "flex-end",
                                    }}
                                    item
                                    xs={12}
                                >

                                </Grid>

                                <FormControl>
                                        <Stack direction="row" spacing={2} alignItems="center">
                                            <TextField type="file" onChange={uploadFilenameChanged} />
                                            <Button variant="contained" color="primary" component="span" startIcon={<CloudUploadIcon />} onClick={uploadButtonClicked}>Upload</Button>
                                        </Stack>
                                    </FormControl>
                                    {uploadProgress > 0 && uploadProgress < 100 && 
                                        <Stack direction="row" spacing={2} alignItems="center">
                                            <Typography variant="body1">Uploading file...</Typography>
                                            <LinearProgress variant="determinate" value={uploadProgress} />
                                        </Stack>
                                    }
                                <Grid height={500}>

                                </Grid>

                            </Paper>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
            <Snackbar
                open={openSnackbar}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
                message={snackbarMsg}
                action={snackbarAction}
            />
        </Container>
    );
};

export default LeadEnhancement;